var map = {
	"./0/Kambi/Rewards.resource": [
		90075,
		5914
	],
	"./0/Poker/Rewards.resource": [
		15346,
		2151
	],
	"./0/Spectate/Rewards.resource": [
		98930,
		6385
	],
	"./1/Kambi/Rewards.resource": [
		34478,
		1661
	],
	"./1/Poker/Rewards.resource": [
		4339,
		438
	],
	"./1/Spectate/Rewards.resource": [
		11505,
		6398
	],
	"./31/Kambi/Rewards.resource": [
		49267,
		6330
	],
	"./31/Poker/Rewards.resource": [
		43418,
		8481
	],
	"./31/Spectate/Rewards.resource": [
		16106,
		6187
	],
	"./58/Spectate/Rewards.resource": [
		93487,
		7762
	],
	"./75/Kambi/Rewards.resource": [
		85547,
		6802
	],
	"./75/Spectate/Rewards.resource": [
		48514,
		7643
	],
	"./76/Kambi/Rewards.resource": [
		33852,
		5867
	],
	"./76/Spectate/Rewards.resource": [
		94731,
		8994
	],
	"./8/Poker/Rewards.resource": [
		80666,
		9151
	],
	"./8/Spectate/Rewards.resource": [
		50858,
		2473
	],
	"./81/Kambi/Rewards.resource": [
		42214,
		1773
	],
	"./81/Spectate/Rewards.resource": [
		20233,
		2172
	],
	"./84/Kambi/Rewards.resource": [
		99831,
		3046
	],
	"./84/Spectate/Rewards.resource": [
		94670,
		5075
	],
	"./86/Spectate/Rewards.resource": [
		95640,
		9677
	],
	"./87/Spectate/Rewards.resource": [
		88231,
		122
	],
	"./88/Spectate/Rewards.resource": [
		82066,
		711
	],
	"./89/Spectate/Rewards.resource": [
		59473,
		4340
	],
	"./90/Spectate/Rewards.resource": [
		11011,
		9961
	],
	"./91/Spectate/Rewards.resource": [
		70804,
		9990
	],
	"./92/Spectate/Rewards.resource": [
		76825,
		3404
	],
	"./94/Spectate/Rewards.resource": [
		61719,
		746
	],
	"./95/Spectate/Rewards.resource": [
		45448,
		9421
	],
	"./96/Poker/Rewards.resource": [
		50263,
		1256
	],
	"./96/Spectate/Rewards.resource": [
		58637,
		128
	],
	"./default/Kambi/Rewards.resource": [
		37048,
		8161
	],
	"./default/Spectate/Rewards.resource": [
		27319,
		2166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51846;
module.exports = webpackAsyncContext;